import React from "react";
import { Doughnut } from "react-chartjs-2";

export default function DoughnutChart(props) {
  const symbol = props.allsymbols;
  const cp = props.allcp;
  const color = props.color;
  const bcolor = props.bcolor;

  const data = {
    labels: symbol,
    datasets: [
      {
        label: "# of Votes",
        data: cp,
        backgroundColor: color,
        borderColor: bcolor,
        borderWidth: 1,
      },
    ],
  };
  return (
    <>
      <div className="header">
        <h1 className="title">MNTREE</h1>
        <div className="links"></div>
      </div>
      {data && <Doughnut data={data} />}
    </>
  );
}
